<!-- eslint-disable no-unused-vars -->
<script setup>
import { ref, watch, defineProps, defineEmits, reactive, onMounted, useTemplateRef, nextTick, computed, getCurrentInstance, defineExpose, shallowRef, h, markRaw } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { sliceEncrypt, filePreview, filesConfig, getSwitchColor, linkedSetEvent, getOrgShowName } from "@/api/global.js";
import { getConfigFromUrl, isJSON } from "@/api/utils";
import { axiosBase } from "@/api/api";
import { tableStatus } from "@/api/utils";
import { getLabelColor } from '@/api/instrumentControl'
import { isConditionAppen, getUserParam, getDateValue, getTextValue, getNumValue, performTakss, getParamsLists } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { isValidateapprovaltimeswitch } from '@/components/schoolInstrument/mixins/utils'
import { archivedata, deletebycondition, batchupdatedata } from "@/port/clientSide/workbench";
import { openapiGetapproval, getuserapprovinglist, getlinkeddatalist } from "@/port/clientSide/oaExamineAudit";
import { cloneDeep } from "lodash";
import { updateapprovingbyfeild } from "@/port/clientSide/oaExamineAudit";
import { dealText } from '@/api/common'
import qs from 'qs'
import { ElMessage, ElMessageBox } from 'element-plus';
import { openapiGetoptions } from "@/port/admins/wordbook";

import oaExamineAudit from "@/components/clientSide/oaExamineAudit.vue";
import DealPrintData from '@/components/common/detailEdit/utils/dealPrintData.utils.js'
import multipleChoice from "@/components/common/multipleChoice"; //组织结构和角色选择

import tableRead from '@/components/clientSide/formFillinPageChild/detailsTable/tableRead.vue'
import simpleButton from '@/components/schoolInstrument/component/mutual/component/button/simpleButton'
import buttonStyle from '@/components/schoolInstrument/component/mutual/component/button/buttonStyle'
import allmultipleChoice from "@/components/common/multipleChoice"; //组织角色选择（平台+空间）
import radioXing from '@/components/clientSide/formFillinPageChild/widgetCommon/radioXing.vue'
import initPage from "@/components/schoolInstrument/component/mutual/component/form/initPage.vue";
import OrderAndScreen from "@/components/common/orderAndScreen.vue";
import richTextEdit from '@/components/common/richTextEditDia.vue' // 富文本编辑
import detailReadonly from '@/components/common/detailReadonly.vue' // 详情只读
import TodoEdit from "./todoEdit.vue";
import widgetLinkOpen from '@/components/clientSide/common/widgetLinkOpen.vue'
import relationUserInfo from '@/components/clientSide/common/relationUserInfo'
import batchDialog from '@/components/clientSide/workbench/batchDialog/index'
import log from '@/components/clientSide/workbench/log/index'
import swipeIndex from '../swipe/index.vue'
import printBox from '@/components/common/detailEdit/excel/printBox.vue'
import oaAddExamineInput from '@/components/schoolInstrument/component/mutual/component/button/oaAddExamineInput.vue'
import annotationTips from '@/components/schoolInstrument/common/annotationTips.vue'
import contextMenu from '@/components/common/contextMenu.vue'
import { MY_CONSTANTS } from '@/util/constants';
import tableDetailCol from './tableDetailCol.vue'
// import { ElIcon, Check, ElSwitch, ElLink, ElImage } from 'element-plus'

const props = defineProps({
  listInfo: {
    type: Object,
    default: () => ({})
  },
  pageId: {
    type: String,
    default: ''
  },
  openAction: {
    type: String,
    default: ''
  },
  pageList: {
    type: Object,
    default: () => ({})
  },
  dataInfo: {
    type: Object,
    default: () => ({})
  },
  aitableHide: {
    type: Boolean,
    default: false
  },
  approvalInfo: {
    type: Object,
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  },
  jurisdiction: {
    type: Object,
    default: () => ({})
  },
  approvalId: {
    type: Number,
    default: 0
  },
  currentOrg: {
    type: Object,
    default: () => ({})
  },
  screenRef: {
    type: Object,
    default: () => ({})
  },
  isGetListData: {
    type: Boolean,
    default: false
  },
  multipleParentSelection: {
    type: Array,
    default: () => ([])
  },
  checkSyllable: {
    type: Array,
    default: () => ([])
  },
})


const emit = defineEmits(['updateTable', 'click-row', 'sourceAudit', 'resetRefresh', 'click-table', 'edit-user-info', 'appPrint', 'change-currpage', 'goSearch', 'open-appDialog', 'smsVerifi', 'toBottom', 'click-table', 'todo-inside', 'todo-outside', 'custom-scene', 'open-dictionary', 'to-nav', 'cardDataDel', 'openDataSync', 'update:multipleParentSelection'])

// 是否为个人空间
let isUpace = false
// 是否为平台空间
let isSpace = false
// 列表操作控件
let showTodoList = {}
// 自定义样式
const vxeTableStyle = {
  '--vxe-ui-table-cell-padding-mini': '0 10px',
  '--vxe-ui-table-row-checkbox-checked-background-color': '#DFE8F6',
  '--vxe-ui-table-row-hover-checkbox-checked-background-color': '#DFE8F6',
  '--vxe-ui-table-row-hover-striped-background-color': '#DFE8F6',
  '--vxe-ui-table-row-hover-background-color': '#DFE8F6',
}

const store = useStore()
const route = useRoute()
const router = useRouter()
const listData = ref({
  currentPage: 1,
  total: 0,
  pagesize: 20,
  data: [],
})

const linkconfig = ref({
  open: false,
  terrace: false,
  link: false,
  field: '',
  openConfig: 'original'
})

// 是否为链接对象
const isLinkObj = ref({})
// 选中的数据
const multipleSelection = ref([])
// 明细控件打开类型
const detailOpenType = ref('')
// 弹窗尺寸
const dialogSize = ref('80%')
// 弹窗打开类型
const componentType = ref('')
// 表格字段信息
const tableKey = ref([])
// 分页条数
const pageSizes = ref([25, 50, 100])
// 区块链
const blockchainChange = ref(false)
// 数据搜索条件
const searchCriteria = ref({})
// 删除和编辑弹窗控制
const batch = ref({ visible: false, title: "", operate: "" })
// 数据日志开关
const isViewLog = ref(false)
// 数据日志数据暂存
const logApprovingId = ref('')
// 打印模板
const printFormdata = ref([])
// 打印预览弹窗的显示隐藏
const printBoxOpen = ref(false)
// 打印预览数据的显示隐藏
const printBoxShow = ref(false)
const deptGroup = ref({})
const printTitle = ref('')
const printBoxConfig = ref({})

// 暂存菜单按钮
const tempBtnMenu = ref([])
// 菜单的位置
const menuPosition = ref({})
// 控制菜单显示
const showMenu = ref(false)
// 暂存菜单信息
const tempMenuInfo = ref({})

const isAllMultipleChoice = ref(false)

const checkShowSet = ref([])

const printBoxKey = ref(0)
const uploadKey = ref(0)

// 暂存的按钮信息
const tempBtnInfo = ref({})

// 暂存的编辑信息
const tempEditInfo = ref({})

const activeCol = ref({})

// 暂存富文本标题
const tempRichAndDetailsName = ref('')
const isRichTextReadonly = ref(false)

const tableBodyHeight = ref('')

const coverVal = ref({})
const isAllAdd = ref(false)
const addDataShow = ref(false)

// 获取this
const currentInstance = getCurrentInstance()

// $refs
const widgetLinkOpenRef = useTemplateRef('widgetLinkOpenRef')
const AuditOpenChild = useTemplateRef('AuditOpenChild')
const swipeIndexRef = useTemplateRef('swipeIndexRef')
const tipsRef = useTemplateRef('tipsRef')
const tableRef = useTemplateRef('tableRef')
const detailReadonlyRef = useTemplateRef('detailReadonlyRef')
const todoEditRef = useTemplateRef('todoEdit')
// const cellTodoEditRef = useTemplateRef('cellTodoEdit')
const richTextEditRef = useTemplateRef('richTextEditRef')
const allMultipleChoiceRef = useTemplateRef('allMultipleChoiceRef')

onMounted(() => {

  if (props.dataInfo.tableStyleField.isTodoList) {
    handleTodoConfig()
  }
  if (['custom', 'textAdaption', 'lineAdaption'].includes(props.dataInfo.tableStyleField.pageNum)) { 
    pageSizes.value.push(props.dataInfo.tableStyleField.customPageNum)
    pageSizes.value.sort((a, b) => a - b)
  }
})

// methods
const handleSizeChange = (val) => {
  listData.value.pagesize = val
  emit('change-currpage', val, 'pageSize')

}


const upClass = ({ row }) => {
  let str = "row_style";
  if (row.cochain === 1 || row.cochain === 2) {
    str += " row_style_back";
  }
  for (const ele of tableKey.value) {
    if (!ele.filedInfo) continue
    if (!ele.filedInfo.isColor) continue
    const colorType = ele.filedInfo.colorType
    if (colorType === '3') {
      str += ' row_style_wholerow'
    }
  }
  return str;
}

const clearActiveCol = () =>{
  activeCol.value.title = ''
  activeCol.value.approvingId = ''
}

const handleDetailCol = (row, column, name) =>{
  activeCol.value.title = name
  activeCol.value.approvingId = row.approvingId || row.approving_id
}

const hideSecondLevelHeader = ({ rowIndex }) => {
  let str = 'row-header-style'
  if (props.dataInfo.pivotConfig && Array.isArray(props.dataInfo.pivotConfig.showLevel) && !props.dataInfo.pivotConfig.showLevel.includes(rowIndex + 1) && props.dataInfo.tableStyleField.filedType === 'pivot') {
    str += ' hidden-header'
  }
  return str
}

const cellDblclick = (e) => {
  const { column } = e
  if (props.dataInfo.tableStyleField.isTodoList && showTodoList[column.property] && showTodoList[column.property].info.interactive === 'doubleClick') {
    goTodoEdit(e, { property:column.property, label: column.title }, 'doubleClick')
  }
}


const headerDragend = ({ columnIndex, resizeWidth: newWidth, $table }) => {
  const li = tableKey.value
  let idx = columnIndex
  if (props.dataInfo.tableStyleField.isSerialNumber) {
    idx = idx - 1
  }
  if (idx === -1) {
    return
  }
  if (isFixed.value) { 
    const oldWidth = li[idx - 1].percentageW
    const nextOldWidth = li[idx].percentageW
    const total = oldWidth + nextOldWidth
    const nextNewWidth = total - newWidth
    $table.setColumnWidth(li[idx - 1].title, newWidth)
    $table.setColumnWidth(li[idx].title, nextNewWidth)
    li[idx - 1].percentageW = newWidth
    li[idx].percentageW = nextNewWidth
  } else {
    li[idx - 1].w = newWidth
  }
}

const closeBatchDialog = () => {
  batch.value = {
    visible: false,
    title: "",
    operate: ""
  }
}

const upCheckbox = ({val, item, row, title}) => {
  row[title] = val
  changeRadioValue({val: val, item: item, row: row}, true)
}

const changeRadioValue = (opt = {}, type = 'radio') => {
  // 单选控件单独写
  let { val, item = {}, row } = opt
  // 判断是否必填和是否规则
  row[item.title] = val
  const obj = {
    approvalId: props.approvalId,
    approvingId: row.approvingId,
    feild: `${item.title}_${item.type}`,
    value: val
  }
  updateAppField(obj)
}

const closeTodoEdit = () => {
  tempEditInfo.value = {}
}

const orgChoiceMethod = (resUser) => {
  const title = tempEditInfo.value.title
  const row = tempEditInfo.value.row
  let valArr = [];
  // 联系人控件
  if(Object.prototype.hasOwnProperty.call(resUser, 'checkedUserArr')){
    resUser.checkedUserArr.forEach(el => {
      let elObj = {
        realname: el.realname,
        userId: el.userId
      };
      // 如果有组织信息
      if (el.orgname) elObj.orgname = el.orgname
      valArr.push(elObj);
    });
  } else if (Object.prototype.hasOwnProperty.call(resUser, 'checkedFlowArr')) {
    resUser.checkedFlowArr.forEach(el => {
      let elObj = {
        name: el.name,
        organizationId: el.organizationId,
        looktype: el.looktype || 0,
        type: el.type
      };
      valArr.push(elObj);
    });
  } else if (Object.prototype.hasOwnProperty.call(resUser, 'checkedRoleArr')) {
    resUser.checkedRoleArr.forEach(el => {
      let elObj = {
        name: el.name,
        roleId: el.roleId
      };
      valArr.push(elObj);
    });
  }
  todoChange({ value: valArr, row, column: { title, type: 'relation-user' } })
}

const handleTodoConfig = () => {
  for (const item of props.dataInfo.listTodoConfig) {
    showTodoList[item.title] = item
  }
}

const changeSwitchValue = (config) => {
  const { item, row } = config
  console.log(row[item.title] !== getSwitchColor({ ele: item, type: 'active', isGet: true }),'asddddddddddd')
  if (row[item.title] !== getSwitchColor({ ele: item, type: 'active', isGet: true }) && row[item.title] !== getSwitchColor({ ele: item, type: 'inactive', isGet: true })) {
    row[item.title] = getSwitchColor({ ele: item, type: 'inactive', isGet: true })
    return
  }
  changeRadioValue(config)
}

const openRichAndDetails = (scope, val) => {
  if (val.type === 'details') {
    openDetailControl({ row: scope.row, filed: val, isReadonly: !(props.dataInfo.tableStyleField.isTodoList && showTodoList[val.title]) })
  } else {
    if (props.dataInfo.tableStyleField.isTodoList && showTodoList[val.title]) {
      // 列表编辑
      goTodoEdit(scope, { property: val.title, label: val.type })
    } else {
      // 列表查看
      const control = props.dataInfo.checkSyllable.find(item=> item.title === val.title)
      openRichText({ value: scope.row[val.title], disabled: true, title: control && control.name })
    }
  }
}

const handleMenuClick = (item) => {
  tableTodoClick(item, tempMenuInfo.value)
}

const richTextEditCallBack = async (val)=> {
  const value = val.formData
  const row = tempEditInfo.value.row
  const { title, type } = tempEditInfo.value
  const obj = {
    approvalId: props.approvalId,
    approvingId: row.approvingId,
    feild: `${title}_${type}`,
    value
  }
  const flag = await updateAppField(obj)
  if (flag) {
    const i = listData.value.data.find(f=>f.approvingId === row.approvingId)
    if (i) {
      i[title] = value
      const filed = tableKey.value.find(f=>f.title === title)
      i.renderMap[title] = setRowData({ row: i}, filed)
    }
  }
  tempEditInfo.value = {}
}

const goTodoEdit = (scope, column, cell, event) => {
  const row = scope.row
  const title = column.property
  const type = column.label
  const config = showTodoList[title]
  if (config === undefined) return
  // if (!props.dataInfo.tableStyleField.isTodoList) return
  const noTodoDialogType = ['richTextWid', 'details']
  // 打开弹窗编辑
  let rect = {}
  if (cell) {
    rect = cell.getBoundingClientRect()
  } else if (event){
    const cellElement = event.currentTarget.closest('.el-table__cell')
    if (cellElement) {
      rect = cellElement.getBoundingClientRect()
    }
  }
  tempEditInfo.value = {
    approvingId: row.approvingId,
    title,
    type,
    config,
    row
  }
  if (props.dataInfo.tableStyleField.isTodoDiagle && type === 'textarea') {
    detailReadonlyRef.value.open({ control: config, textareaValue: row[title], row }, 'textarea')
    return
  }
  if (props.dataInfo.tableStyleField.isTodoDiagle && type === 'relation-user') {
    toGetValue({ val: {}, item: showTodoList[title], row })
    return
  }
  if (props.dataInfo.tableStyleField.isTodoDiagle && !noTodoDialogType.includes(column.label)) {
    todoEditRef.value.open({ row, column: showTodoList[title], rect })
    return
  }
  if (type === 'details') {
    openDetailControl({ row, filed: { title, type }, isReadonly: false })
    return
  }
  if (type === 'richTextWid') { 
    openRichText({ value: row[title], disabled: false, title: config.name })
    return
  }
  nextTick(() => {
    console.log(rect,'rectrectrect')
    todoEditRef.value.open({ row, column: showTodoList[title], rect })
  })
}

const toGetValue = (opt) => {
  let { item, row } = opt
  let data = cloneDeep(item)
  let val = row[data.title]
  if (val) {
    val = typeof val === 'string' ? JSON.parse(val) : val
  }
  const _info = {
    id: props.approvalId,
    info: val,
    data
  }
  const param = getUserParam(_info)
  // 选择角色控件，并且角色查看范围设置位全部角色（调用平台角色+空间角色弹窗）
  if(data.type == 'roule' && data.lookRMSIsUserRole == 2){
    delete param.onlyUser
    param.curHigh = isSpace ? 3 : 1
    allMultipleChoiceRef.multipleChoiceMethod(param);
    isAllMultipleChoice.value = true;
  } else{
    allMultipleChoiceRef.value.multipleChoiceMethod(param);
    isAllMultipleChoice.value = true;
  }      
}

const openRichText = (opt = {}) => {
  const { value, disabled = false, title = '', todoOption = {} } = opt
  const bindinf = value
  isRichTextReadonly.value = disabled
  tempRichAndDetailsName.value = title
  richTextEditRef.value.open({ bindinf })
}


const openDetailControl = async (opt = {}) => {
  const { filed, isReadonly = true, row } = opt
  const value = cloneDeep(row[filed.title])
  if (!isReadonly) {
    const param = {
      key: 2,
      data: row,
    }
    detailOpenType.value = 'detail'
    emit("sourceAudit", param, filed)
    return
  }
  let property = props.approvalInfo.property
  if (property) {
    property = typeof property === 'string' ? JSON.parse(property) : property
  } else {
    const __par = { approvalId: props.approvalId }
    if (isUpace) {
      let upaceId = typeof(route.query.upaceid) !== 'undefined' ? route.query.upaceid : localStorage.getItem('upaceid')
      __par.upaceid = upaceId
    }
    const { code, data } = await openapiGetapproval(__par)
    if (code === 0) property = typeof data.property === 'string' ? JSON.parse(data.property) : data.property
    else return ElMessage.error('获取配置失败')
  }
  const control = property.find(f=>f.title === filed.title)
  const formdata = typeof value === 'string' ? JSON.parse(value) : value
  formdata.pop()
  const fileControl = control.list.find(f=> f.type === 'file')
  if (fileControl) {
    for (const ele of formdata) {
      const file = ele[`${fileControl.title}_${fileControl.type}`]
      if (file && file.length > 0) {
        let newFiled = file.map(f=>{
          let name = f.response ? f.response.split('/')[f.response.split('/').length - 1] : ''
          name = name.split('-')[name.split('-').length - 1]
          return {
            ...f,
            url: currentInstance.proxy.$imgurl + f.response,
            name
          }
        })
        ele[`${fileControl.title}_${fileControl.type}`] = newFiled
      }
    }
  }
  // 将明细控件改为只读
  control.per = 2
  control.list.forEach(item=> {
    item.per = 2
  })
  if (filed.filedInfo && filed.filedInfo.detailed && filed.filedInfo.detailed.fieldAppen && filed.filedInfo.detailed.fieldAppen.length > 0) {
    control.list = control.list.filter(f=> filed.filedInfo.detailed.fieldAppen.includes(`${f.title}_${f.type}`))
  }
  detailReadonlyRef.value.open({
    formdata,
    control,
  }, 'details')
}

const todoChange = async (opt = {}) => {
  const { row, column, value } = opt
  const obj = {
    approvalId: props.approvalId,
    approvingId: row.approvingId,
    feild: `${column.title}_${column.type}`,
    value
  }
  const flag = await updateAppField(obj)
  if (flag) {
    const i = listData.value.data.find(f=> f.approvingId === row.approvingId)
    if (i) {
      i[column.title] = value
      const filed = tableKey.value.find(f=>f.title === column.title)
      i.renderMap[column.title] = setRowData({ row: i}, filed)
    }
  }
}

const updateAppField = async (obj) => {
  const res = await updateapprovingbyfeild(obj)
  if (res.code === 0) {
    ElMessage.success('修改成功')
    return true
  } else {
    ElMessage.error(res.msg)
  }
}

const openBtnTips = (config) => {
  tipsRef.value.open(config)
}

const rowContextmenu = (row, column, event) => {
  if (!props.dataInfo.tableStyleField.isRightClickBtn) return
  event.preventDefault()
  tempBtnMenu.value = tableTodoListComp({ row }, props.dataInfo.rightTodoList)
  tempMenuInfo.value = {
    row,
    rowIndex: column.idx
  }
  // 鼠标点击的原始坐标
  const mouseX = event.clientX;
  const mouseY = event.clientY;

  // 获取视口（Viewport）尺寸
  const viewportW = window.innerWidth || document.documentElement.clientWidth;
  const viewportH = window.innerHeight || document.documentElement.clientHeight;

  const menuW = 200; // 菜单在 CSS 中定义的宽度
  const menuH = 32 * tempBtnMenu.value.length; // 菜单的总高度 (假设有3个菜单项，每个30px，上下padding)
  let finalX = mouseX;
  let finalY = mouseY;

  // --- 垂直方向判断（Y轴） ---
  // 如果鼠标Y坐标 + 菜单高度 > 视口高度，说明菜单底部超出屏幕
  if (mouseY + menuH > viewportH) {
      // 将菜单向上移动，使其顶部对齐鼠标点击位置 (或略微向上移)
      // 调整到：鼠标Y坐标 - 菜单高度
      finalY = mouseY - menuH;

      // 进一步判断：如果向上移动后，顶部超出屏幕，则固定到屏幕顶部
      if (finalY < 0) {
          finalY = 0;
      }
  }

  // --- 水平方向判断（X轴） ---
  // 如果鼠标X坐标 + 菜单宽度 > 视口宽度，说明菜单右侧超出屏幕
  if (mouseX + menuW > viewportW) {
      // 将菜单向左移动，使其右侧对齐鼠标点击位置
      // 调整到：鼠标X坐标 - 菜单宽度
      finalX = mouseX - menuW;

      // 进一步判断：如果向左移动后，左侧超出屏幕，则固定到屏幕左侧
      if (finalX < 0) {
          finalX = 0;
      }
  }

  menuPosition.value = {
    x: finalX,
    y: finalY
  }
  showMenu.value = true
}

const menuClose = () => {
  showMenu.value = false
  tempMenuInfo.value = {}
}

const getRowClassName = ({ row, rowIndex }) => {
  if (tempMenuInfo.value && tempMenuInfo.value.row) {
    return rowIndex === tempMenuInfo.value.rowIndex ? 'row--checked' : ''
  }
}

const clearCheckboxRow = ()=> {
  multipleSelection.value = []
}

const updateElTable = ()=>{
  // uploadKey.value++
}


const tableTodoListComp = (scope, li) => {
  if (Object.keys(props.jurisdiction).length === 0) return []
  const log = props.pageId === '7' || props.pageId === '6' ? 'oplog' : 'myoplog'
  if (!li) li = props.dataInfo.clientTableTodoList
  let arr = li.filter(item => {
    // 一个一个去判断按钮是否显示
    let isAppen = true
    if(item.conditionAppen && Object.keys(item.conditionAppen).length > 0){
      const customData = store.state.doorCustomDataObj[props.customDeskId] || undefined
      isAppen = isConditionAppen(item.conditionAppen, scope.row, true, customData)
    }
    if (item.id === 1 && props.jurisdiction.update && item.isShow) {
      // 编辑
      if (scope.row.archive && !isDelAndEdit(scope.row, 'update')) {
        return false
      }
      return isAppen
    } else if (item.id === 2 && props.jurisdiction.delete && item.isShow) {
      // 删除
      if (item.id === 2 && !isDelAndEdit(scope.row, 'delete')) {
        return false
      }
      return isAppen
    } else if (item.id === 3 && props.jurisdiction[log] && item.isShow) {
      // 数据日志
      return isAppen
    } else if (item.id === 4 && scope.row.cochain &&(scope.row.cochain === 1 || scope.row.cochain === 2) && item.isShow) {
      // 区块链
      return isAppen
    } else if (item.id === 5 && props.jurisdiction.oqrcore && item.isShow) {
      // 数据二维码
      return isAppen
    }
    else if (item.id === 6 && JSON.stringify(scope.row.archive) && props.jurisdiction.archive && item.isShow) {
      // 数据归档
      return isAppen
    } else if (item.id === 99 && item.isShow) {
      return isAppen
    } else if ([1, 2, 3, 4, 5, 6].indexOf(item.id) === -1) {
      return isAppen
    }
  })
  return arr
}

const isDelAndEdit = (row, type = 'delete') => {
  const obj = {
    delete: 'manualDoNotDel',
    update: 'manualDoNotModify' 
  }
  let isAppen = props.jurisdiction[type] && row.archive && row[obj[type]]
  isAppen = typeof isAppen === 'string' ? JSON.parse(isAppen) : isAppen
  if (props.jurisdiction[type] && !row.archive) {
    return true
  } else if (isAppen) {
    return false
  } else {
    return props.jurisdiction[type]
  }
}

const batchRet = (val) => {
  if (batch.value.operate === "del") {
    if (val.radio === 1) {
      deleteRowFun(2);
    } else {
      setDeletebycondition(val);
    }
  } else if (batch.value.operate === "export") {
    checkShowSet.value = (val.center || []).filter((item) => {
      return item.checked;
    });
    exportexcel(val);
  } else if (batch.value.operate === "update") {
    // 这里是修改回来
    const obj = {
      approvalId: props.approvalId,
      reportFormId: searchCriteria.value.reportFormId,
      type: 0,
      curpage: 1,
      pagesize: 10000,
      cateId: -1,
      key: searchCriteria.value.key,
      conditionconfig: val.conditionconfig,
    };
    if (val && val.radio === 1) {
      obj.approvingIds = (multipleSelection.value || [])
        .map((its) => its.approvingId)
        .join(",");
    } else if (val && val.radio === 2) {
      obj.query = searchCriteria.value.query;
    } else if (val && val.radio === 3) {
      obj.query = { date_timeof: val.time };
    }
    if (val.isarchive !== "") obj.isarchive = val.isarchive;
    batchUpdate(obj);
  }
  batch.value = {
    visible: false,
    title: "",
    operate: "",
  };
}

const batchUpdate = async (item) => {
  const res = await batchupdatedata(item);
  if (res.code === 0) {
    ElMessage.success("操作成功");
  } else {
    ElMessage.error(res.msg || "操作失败");
  }
}

const swipeRet = async (val)=> {
  switch (tempBtnInfo.value.bindingFunction) {
    case 'swipeAdd':
      {
        const flag = await isValidateapprovaltimeswitch({type: 1,approvalId: props.approvalId })
        if (flag) return
        coverVal.value = val
        isAllAdd.value = false
        addDataShow.value = true
      }
      break
    case 'swipeUp':
      {
        let str = '/clientSide/application'
        const ob1 = {
          approvalId: props.approvalId,
          iId: 14,
          source: 'user',
          name: props.dataInfo.apply.name,
          navShow: false,
          dataId: 14,
          search: JSON.stringify(val)
        }
        str += ('?' + qs.stringify(ob1))
        const obj = {
          approvalId: props.approvalId,
          datatype: 1,
          iId: 14,
          popUps: {
            customSize: 65,
            diaSize: '80%',
            h: 800,
            open: 2,
            w: 1700
          },
          search: str
        }
        emit('openAppInitiate', obj)
      }
      break
  }
}

const exportexcel = (item) => {
  // 固定参数
  const param = JSON.parse(JSON.stringify(searchCriteria.value));
  param.curpage = 0;
  param.pagesize = 0;
  const checkShowSetValue = JSON.parse(JSON.stringify(checkShowSet.value));
  checkShowSetValue.forEach((e) => {
    e.checked = true;
  })
  param.content = JSON.stringify(checkShowSetValue);
  param.reportFormId = searchCriteria.value.reportFormId;
  param.key = searchCriteria.value.key;

  if (item.radio === 1) {
    param.approvingIds = multipleSelection.value
      .map((its) => its.approvingId)
      .join(",");
  } else if (item.radio === 2) {
    param.query = searchCriteria.value.query;
  } else if (item.radio === 3) {
    param.query = { date_timeof: item.time };
  }
  // 从空间进入，需要传空间id
  if(isSpace){
    let spaceId = typeof(route.query.spaceid) !== 'undefined' ? route.query.spaceid : localStorage.getItem('spaceid')
    param.spaceid = spaceId;
  }
  else if (isUpace) {
    let upaceId = typeof(route.query.upaceid) !== 'undefined' ? route.query.upaceid : localStorage.getItem('upaceid')
    param.upaceid = upaceId
  }
  // 第三个参数是导出的接口过期时间
  axiosBase(param, "/api/exportreport", 60 * 1000 * 3).then((res) => {
    if (res && res.code == 0) {
      filePreview({ url: res.data }, true);
    }
  });
}

const setDeletebycondition = async (item)=> {
  const param = {
    approvalId: props.approvalId,
    reportFormId: searchCriteria.value.reportFormId,
    type: 0,
    curpage: 1,
    pagesize: 10000,
    cateId: -1,
    key: searchCriteria.value.key,
  };
  if (item && item.radio === 2) {
    param.query = searchCriteria.value.query;
  } else if (item && item.radio === 3) {
    param.query = { date_timeof: item.time };
  }
  const res = await deletebycondition(param);
  if (res.code === 0) {
    ElMessage.success(res.msg || "删除成功!");
    // 计算删除之后的数据列表
    if (
      listData.value.data.length === 0 && searchCriteria.value &&
      searchCriteria.value.curpage > 1
    ) {
      searchCriteria.value.curpage -= 1;
    }
    emit("resetRefresh", "del");
  } else {
    ElMessage.error(res.msg || "删除失败!");
  }
}

const tableTodoClick = async (info, scope) => {
  const row = scope.row
  const bindingFunction = info.bindingFunction
  if (bindingFunction === 'edit') {
    // 编辑
    tableUpdate(row)
    return
  } else if (bindingFunction === 'edit-user') {
    // 编辑用户
    const data = info.editUser || {}
    emit('edit-user-info', data, row)
    return
  } else if (bindingFunction === 'todoinside') {
    // 站内应用
    const insideInfo = info.insideInfo
    emit('todo-inside', { row, insideInfo })
    return
  } else if (bindingFunction === 'todooutside') {
    // 站外应用
    const insideInfo = info.insideInfo
    emit('todo-outside', { row, insideInfo })
    return
  } else if (['app-detail', 'app-comment'].includes(bindingFunction)) {
    // 查看详情
    openDetailInfo([bindingFunction, info], row)
    return
  } else if (bindingFunction === 'dictionary') {
    // 字典
    let info = info.info.dictionaryInfo
    const par = {
      optionsId: info.optionsId
    }
    const res = await openapiGetoptions(par)
    if (res.code === 0) {
      emit('open-dictionary', res.data)
    } else {
      ElMessage.error(res.msg)
    }
    return
  } else if (bindingFunction === 'toNav') {
    // 跳转导航
    emit('to-nav', info.toNavInfo)
    return
  } else if (['swipeAdd', 'swipeUp'].includes(bindingFunction)) {
    // 刷卡新增和修改
    swipeIndexRef.value.open(info)
    tempBtnInfo.value = info
    return
  } else if (bindingFunction === 'del') {
    // 删除
    const idx = listData.value.data.findIndex((item) => item.approvingId === row.approvingId)
    deleteRow(1, idx)
    return
  } else if (bindingFunction === 'dataLog') {
    // 数据日志
    viewLogFun(row)
    return
  } else if (bindingFunction === 'dataArchiving') {
    archiveFun(row)
    return
  } else if (bindingFunction === 'app-print') {
    if (info.info.printId === -1) {
      emit('appPrint', row)
    } else {
      goCustomPrint(info, row)
    }
    return
  } else if (bindingFunction === 'custom-scene') {
    handleCustomScene(row, info)
  } else if (bindingFunction === 'dataSynchronization') {
    emit('openDataSync', info, scope.row)
  } else if (bindingFunction === 'page-inner') {
    const link = info.innerPageConfig.innerLink
    const query = {}
    const user = localStorage.getItem('user')
    if (user) {
      const token = JSON.parse(user).accesstoken
      query.accesstoken = token
    }
    for (const ele of link) {
      const title = ele.title
      query[ele.submitName] = row[title]
    }
    const url = `/previewfiles/${info.innerPageConfig.fileUrl}`
    const open = info.insideInfo.open
    if (open === 4) {
      // 原页面
      router.push({ path: url, query })
    } else if (open === 3) {
      // 新页面
      const pathurl = MY_CONSTANTS.$apiurl + url
      window.open(`${pathurl}?${qs.stringify(query)}`, '_blank')
    } else if (open === 2 || open === 5) {
      const popUps = info.insideInfo.popUps
      const obj = {
        2: 'dialog',
        3: 'new',
        4: 'old',
        5: 'rightdia'
      }
      const dialogUrl = MY_CONSTANTS.$apiurl + url + '?' + qs.stringify(query)
      const param = {
        isVisible: true,
        dialogName: '页面嵌入',
        dialogWidth: popUps.w + 'px',
        dialogHeight: popUps.h + 'px',
        openType: obj[open],
        dialogUrl,
        customSize: popUps.customSize,
        diaSize: popUps.diaSize,
      }
      emit('open-appDialog', param)
    }
  }
}

const handleCustomScene = (row, info) => {
  const { open, popUps } = info.insideInfo
  const custom = info.customScene
  const skey = route.query.skey || route.params.skey
  const url = '/customInstrument'
  let paramsList = cloneDeep(custom.paramsList || [] )
  let paramsLists = []
  // 页面入参
  if (paramsList.length > 0) {
    let customData = store.state.doorCustomData
    const obj = {
      paramsList: paramsList,
      customData,
      currentOrg: props.currentOrg,
      screen: props.screenRef,
      tableData: row
    }
    paramsLists = getParamsLists(obj)
  }
  const query = { showNav: false, name: custom.params, customDeskId: custom.id }
  if (skey) {
    query.skey = skey
  }
  if (paramsLists.length > 0) query.paramsList = JSON.stringify(paramsLists)
  if (open === 2 || open === 5) {
    // 弹窗
    emit('custom-scene', {url:`${url}?${qs.stringify(query)}`,popUps, open, query})
  } else if (open === 3) {
    // 新窗口
    // window.open(`${url}?${qs.stringify(query)}`, '_blank')
    currentInstance.proxy.$openNewPage(url, query)
  } else if (open === 4) {
    // 当前窗口
    // window.location.replace(url);
    router.push({ path: url, query })
  } else {
    ElMessage.error('请选择打开方式')
  }
}

const goCustomPrint = async (info, row) => {
  let obj = {
    approvalId: props.approvalId
  }
  if (isUpace) {
    let upaceId = typeof(route.query.upaceid) !== 'undefined' ? route.query.upaceid : localStorage.getItem('upaceid')
    obj.upaceid = upaceId
  }
  const { code, data } = await openapiGetapproval(obj)
  if (code === 0) {
    // 获取本应用的模板
    let pagesets = JSON.parse(data.pageset)
    if (pagesets && pagesets.url) {
      pagesets = await getConfigFromUrl(currentInstance.proxy.$url + pagesets.url)
    }
    if (!Array.isArray(pagesets)) return
    const pageset = pagesets[3].printConfig.find(item => item.id === info.info.printId)
    if (pageset) {
      openPrint({ printConfig: pageset, approvalId: props.approvalId }, row)
    } else {
      ElMessage.error('请选择打印模板')
    }
  }
}

const openPrint = async (payload, rowData) => {
  const printConfig = payload.printConfig
  const ruleList = payload.ruleList
  printBoxOpen.value = true
  // 处理一下本表数据
  printFormdata.value = await getFromdata(rowData, payload.approvalId)
  printTitle.value = printConfig.canvasName
  // 兼容一下旧配置
  printBoxConfig.value = JSON.parse(JSON.stringify(compatibleSheetCongfig(printConfig)))
  // 判断是否有他表的数据
  if (printConfig.dataSource.formList && printConfig.dataSource.formList.length>0) {
    let spaceId, upaceId
    if (isSpace) {
      spaceId = typeof(route.query.spaceid) !== 'undefined' ? route.query.spaceid : localStorage.getItem('spaceid')
    } else if (isUpace) {
      upaceId = typeof(route.query.upaceid) !== 'undefined' ? route.query.upaceid : localStorage.getItem('upaceid')
    }
    const res = await DealPrintData.getOtherApproval(printConfig, printFormdata.value, spaceId, upaceId)
    if (res.deptGroup !== undefined) {
      deptGroup.value = JSON.parse(JSON.stringify(res.deptGroup))
      delete res.deptGroup
    } else {
      deptGroup.value = {}
    }
    printFormdata.value = { ...printFormdata.value, ...res }
  }
  // 获取一下联系人其他的数据和单选存储值的兼容
  printFormdata.value = await DealPrintData.getRelationUserInfo(JSON.parse(JSON.stringify(printFormdata.value)))
  printFormdata.value = await DealPrintData.dealRadioLabel(JSON.parse(JSON.stringify(printFormdata.value)), ruleList)
  printBoxShow.value = true
}

const getFromdata = async (rowData, approvalId) => {
  let res = {}
  const query = {
    curpage: 0,
    pagesize: 0,
    approvingId: rowData.approvingId,
    approvalId
  }
  // 请求本表的数据
  const {data, code} = await getuserapprovinglist(query)
  if (code === 0) {
    res = JSON.parse(data[0].approving.formdata)
    // 获取默认的字段
    const defaultKey = {}
    const defaultKeyList = ['申请人_relation-user', '单号_text', '状态_status', '提交时间_date', '归档状态_status']
    defaultKeyList.forEach(item => {
      defaultKey[item] = DealPrintData.handleDefaultKey(item, data[0])
    })
    res = { ...res, ...defaultKey }
  }
  return res
}

const compatibleSheetCongfig = (config) => {
  let resultConfig = JSON.parse(JSON.stringify(config))

  if (resultConfig.sheetList.length > 0 && resultConfig.sheetList[0].sheets && resultConfig.sheetList[0].sheets.length > 0) {
    const sheetList = resultConfig.sheetList[0].sheets
    // 删除原来配置的 工作表
    delete resultConfig.sheetList[0].sheets
    // 旧的全局配置
    const sheetOldConfig = JSON.parse(JSON.stringify(resultConfig.sheetList[0]))
    sheetList.forEach(item => {
      // 将原来的全局配置分配给每个工作表
      if (resultConfig.sheetConfig === undefined) resultConfig.sheetConfig = {}
      resultConfig.sheetConfig[item.index] = {...sheetOldConfig}
    })
    resultConfig.sheetList = sheetList
  }
  return resultConfig
}

const viewLogFun = (item) => {
  logApprovingId.value = item.approvingId;
  isViewLog.value = true;
}

const deleteRow = (type, index, key) => {
    // 这里要换成多选弹窗(新版的)
  if (type === 2) {
    batch.value = {
      visible: true,
      title: "删除",
      operate: "del",
      repeat: true,
      batchQuery: searchCriteria.value.query || "",
      dateLen: multipleSelection.value.length,
    }
  } else {
    // type:1单个删除，2多个删除, 3单个删除 直接使用approvingId删除不需要通过index查询
    ElMessageBox.confirm("确定要删除？", {
      confirmButtonClass: "el-button--yeprimary",
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        if (type === 1 || type === 3) {
          deleteRowFun(type, index, key);
        } else {
          deleteRowFun(2);
        }
      })
      .catch((err) => {
        console.log(err,'err');
      });
  }
}

const getBodyHeight = () => {
  if (props.dataInfo.tableStyleField?.pageNum !== 'lineAdaption') return
  const ref = tableRef.value?.$el
  if (ref) {
    setTimeout(() => {
      const bodyWrapper = ref.querySelector('.el-table__body-wrapper')
      if (bodyWrapper) {
        const height = bodyWrapper.getBoundingClientRect().height - 1
        tableBodyHeight.value = height
        return height
      }
    }, 1000);
  }
}

//表格删除方法
const deleteRowFun = (res, index, key) => {
  //type:1单个删除，2多个删除.index单个删除 3 直接把approvingId传过来了 不用通过index去查approvingId
  const resIsDel = res;
  let tableData = listData.value.data
  let param = {
    approvalId: props.approvalId,
  };
  if (resIsDel === 1) {
    param.approvingId = tableData[index].approvingId;
  } else if (resIsDel === 3) {
    param.approvingId = index
  } else {
    const arr = (multipleSelection.value || []).map(
      (its) => its.approvingId
    );
    param.approvingId = arr.length === 1 ? arr[0] : arr;
  }
  console.log(param, "param");
  axiosBase(param, "/api/deleteapproving").then((res) => {
    if (res.code == 0) {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      if (resIsDel === 1) {
        //单个视图跟新
        tableData.splice(index, 1);
        if (key === 'card') {
          emit('cardDataDel', index)
        }
      } else {
        //多个视图更新和单个
        if (typeof param.approvingId == "number") {
          //单个
          listData.value.data.forEach((el2, index) => {
            if (el2.approvingId == param.approvingId) {
              listData.value.data.splice(index, 1);
            }
          });
        } else {
          param.approvingId.forEach((el) => {
            listData.value.data.forEach((el2, index) => {
              if (el == el2.approvingId) {
                listData.value.data.splice(index, 1);
              }
            });
          });
        }
      }
      // 计算删除之后的数据列表
      if (
        listData.value.data.length === 0 && searchCriteria.value &&
        searchCriteria.value.curpage > 1
      ) {
        searchCriteria.value.curpage -= 1;
      }
      emit("resetRefresh", "del");
    } else {
      ElMessage.error(res.msg);
    }
  });
}

const setRowData = (scope, i) => {
  const { row } = scope
  const renderContent = {}
  if (i.type === 'image' || i.type === 'file') {
    renderContent.displayValue = isJSON(row[i.title])
    renderContent.displayValue.forEach(item => {
      item.display = strImgAndFileData(item)
    })
  } else if (i.type === 'number') {
    renderContent.displayValue = getResValue(toDecimal(row[i.title]), i, scope)
  } else if (i.type === 'date') {
    renderContent.displayValue = getTimeLabels(i, scope)
  } else if (i.type === 'location') {
    renderContent.displayValue = getLocationVal(row[i.title])
  } else if (i.title === '状态') {
    renderContent.displayValue = row[i.title]
  } else if (i.title === '归档状态') {
    renderContent.displayValue = getArchive(row)
  } else if (i.type === 'checkbox') {
    renderContent.displayValue = row[i.title]
  } else {
    renderContent.displayValue = getResValue(getValue(scope, i), i, scope)
  }
  const statusClass = i.title === '状态' ? tableStatus(row['status']) : '';
  let cellStyle = {
    ...tableLine.value, // 基础样式
    ...numFormatStyle(getValue(scope, i), i), // 数字格式化样式
    ...props.dataInfo.listStyleConfig.valueConfig,
    justifyContent: getConfigCenter(props.dataInfo.listStyleConfig.valueConfig.textAlign),
  }
  if (i.type !== 'checkbox') {
    const obj = labelColor(getValue(scope, i), i) // 颜色逻辑
    cellStyle = { ...cellStyle, ...obj }
  }
  const parentStyle = {
    justifyContent: getConfigCenter(props.dataInfo.listStyleConfig.valueConfig.textAlign),
    height: getCellHeight.value,
    lineHeight: getCellHeight.value,
  }
  // 注释掉的原因是因为如果说给了高度，行高就不会居中了

  if (showTodoList[i.title] && i.type === 'radio' && (showTodoList[i.title].types === 4 || showTodoList[i.title].types === 6)) {
    cellStyle.justifyContent = 'center'
  }
  if (i.type === 'textarea') {
    cellStyle.whiteSpace = 'pre-wrap'
  }
  
  // cellStyle.color = renderContent.displayValue ? '' : '#999'
  if ((renderContent.displayValue !== 0 && !renderContent.displayValue) && showTodoList[i.title]) {
    cellStyle.color = 'rgb(192, 196, 204) !important'
  }
  return {
    display: renderContent.displayValue,
    style: cellStyle,
    statusClass: statusClass,
    placeholder: getPlaceholder(i),
    parentStyle
  }
}

const getResData = (val) => {
  // 在这边直接处理样式和数据
  let li = val.map(row => {
    const scope = { row: row }
    const renderMap = {}
    props.checkSyllable.forEach((i) => {
      const obj = setRowData(scope, i)
      renderMap[i.title] = obj
    })
    const todoList = markRaw(tableTodoListComp(scope))
    return {
      ...markRaw(row),
      renderMap: renderMap,
      todoList
    }
  })
  return li
}

const strImgAndFileData = (val) => {
  if (!val) return ''
  let filename = ''
  if (typeof val === 'object') {
    filename = val.realname || val.response || ''
  } else {
    filename = val
  }
  if (!filename) return ''
  try {
    const mps = filename.split('/')
    const mp = mps[mps.length - 1]
    const li = mp.split('-')
    let str = ''
    if (li.length > 2) {
      li.shift()
      str = li.join('-')
    } else {
      str = mp.split('-')[1]
    }
    return str || filename
  } catch (err) {
    return filename
  }
}

const getConfigCenter = (type = 'left') => {
  const obj = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
  }
  return obj[type]
}

const getArchive = (row) => {
  const archive = typeof row.archive === 'undefined' ? 0 : row.archive
  const obj = {
    0: '未归档',
    1: '已归档'
  }
  return obj[archive]
}

const getLocationVal = (data) => {
  if (data == '') return ''
  const val = typeof data === 'string' ? JSON.parse(data) : data
  if (val.length > 0) {
    return val[0]['addressName']
  }
  else {
    return ''
  }
}

const getTimeLabels = (val, scope) => {
  if (!val || !scope) return ''
  if (val.type === 'date' && scope.row[val.title] && val.timeList && val.timeList.open && val.timeList.options && val.timeList.options.length > 0) {
    const label = getTimeLabel(scope.row[val.title], val.timeList.options)
    return label
  }
  let value = getResValue(getValue(scope, val), val) || (showTodoList[val.title] && showTodoList[val.title].placeholder)
  if (value && value.includes('1970-01-01')) {
    try {
      value = value.split(' ')[1].split(':').slice(0, 2).join(':')
    } catch (err) { console.log(err) }
  }
  return value
}


const getTimeLabel = (val, sels) => {
  if (!val || !sels || sels.length === 0) return val
  const v = val.split(' ')
  for (const i of sels) {
    if (i.value === v[1]) return v[0] + ' ' + i.label
  }
  return val
}

const getPlaceholder = (val) => {
  const column = showTodoList[val.title]
  if (column) {
    if (column.info && column.info.placeholder) {
      return column.info.placeholder
    } else {
      return ''
    }
  } else {
    return ''
  }
}

const toDecimal = (num) => {
  if (typeof num === 'string') {
    const number = num.split('.').length > 1 ? Number(num).toFixed(2) : num
    return +number
  }
  return num
}

const numFormatStyle = (val, filed) => {
  if (filed.type !== 'number') return
  if (filed && filed.filedInfo && filed.filedInfo.configNumber && filed.filedInfo.configNumber.markedRed && Number(val) < 0) {
    return {
      color: '#ff0000'
    }
  }
}

const labelColor = (val, filed) => {
  if (!filed.filedInfo) return
  if (!filed.filedInfo.isColor) return
  const list = filed.filedInfo.list
  const obj = getLabelColor({ options: list }, val, undefined ,filed.filedInfo.colorType || '1')
  obj.height = `${parseInt(props.dataInfo.tableStyleField.listLineHeight || '32px') - 8}px`
  obj.lineHeight = `${parseInt(props.dataInfo.tableStyleField.listLineHeight || '32px') - 8}px`
  obj.width = 'fit-content'
  return obj
}

const queryData = async (rowData, val) => {
  let ele = val
  axiosBase(
    {
      approvalId: route.query.approvalId || props.approvalId,
      approvingId: rowData.approvingId,
      feild: val.title + '_' + val.type
    },
    "/openapi/getsearchbuttoninfo"
  ).then(async (res) => {
    if (res.code === 0) {
      let param = linkedSetEvent(res.data.dataconfig, JSON.parse(res.data.data), {
        types: false
      });
      ele.dataconfig = res.data.dataconfig
      if (param) {
        param.approvingId = rowData.approvingId
        let x = await awaitGetlinkeddatalist(param)
        linkeddataResult(ele, x, rowData)
      }
    }
  });
}

const awaitGetlinkeddatalist = (pargam) => {
  return new Promise(function (resolve) {
    pargam.approvalId = route.query.approvalId || props.approvalId
    getlinkeddatalist(pargam).then(res => {
      resolve(res.data);
    });
  });
}
//- 联动后返回需要加入formdata关联一级控件或者明细控件的数据
const linkeddataResult = (item, res, rowData) => {
  console.log('返回联动', item, res)
  let resultVal
  const listData = listData.value.data
  //- 控件后台给的数据错误少了一个层级
  if (res !== null) {
    // 填充查询
    if (item.dataconfig && item.dataconfig.setUpValue === 1) {
      resultVal = res[0]
    } else {
      // 点击查询
      resultVal = res;
    }
    for (let i = 0; i < listData.length; i++) {
      if (listData[i].approvingId === rowData.approvingId) {
        listData[i][item.title] = resultVal
        break;
      }
    }
  }
}

const getResValue = (val, filed, scope = {}) => {
  let str = val
  if (val !== 0 && !val) return ''
  if (filed.type === 'date' || filed.title === '提交时间') {
    str = getDateValue(val, filed, scope.row)
  } else if (filed.type === 'number') {
    str = getNumValue(val, filed)
  } else if (filed.type === 'text') {
    str = getTextValue(val, filed)
  }
  return str
}

const getRelCheck = (item) => {
  try {
    if (typeof item === 'object') {
      return item.top && item.data && item.data.length > 0 ? item : false
    } else {
      return JSON.parse(item)
    }
  } catch (e) {
    console.log(e)
    return false
  }
}

const getFileFormat = (name) => {
  if (!name) return false
  let site = name.lastIndexOf(".");
  let format = name.substring(site + 1, name.length);
  format = format.toLocaleLowerCase()
  const formatList = ['mp3', 'mp4', 'aac', 'mp4', 'wmv', 'avi', 'flv']
  return formatList.includes(format)
}
const playFun = (val) => {
  const name = val.response
  let site = name.lastIndexOf(".");
  let format = name.substring(site + 1, name.length);
  format = format.toLocaleLowerCase()
  const url = getCurrentInstance.$url + val.response
  const videoList = ['mp4', 'wmv', 'avi', 'flv']
  if (videoList.includes(format)) {
    getCurrentInstance.$videoPlayer().paly(url)
  } else {
    getCurrentInstance.$musicPlayer().paly(url)
  }
}

const goPreview = (val, down, isEdit) => {
  filePreview(val, down, isEdit)
}

const getWidth = (item, type, idx) => {
  let w = ''
  if (type === 'sel') {
    w = 40
  } else if (type === 'num') {
    w = props.dataInfo.tableStyleField.idxWidth || 50
  } else {
    if (isFixed.value) {
      w = item.percentageW
    } else {
      w = item.w
    }
  }
  return w
}

const handleCurrentChange = (val) => {
  listData.value.currentPage = val
  emit('change-currpage', val, 'currentPage')
}

const handleSelectionChange =  (val)=> {
  multipleSelection.value = val;
  store.commit('getTableData', val); // ai小易-数据表格存储选中数据
  if (props.listInfo) {
    emit("update:multipleSelection", val);
  }
}

const openDetail = (row, openInfo) => {
  let param = {
    approving: {
      approvingId: row.approvingId,
    },
    userapprovingId: row.userApprovingId,
    approvalId: route.query.approvalId || props.approvalId,
  };
  // openAction ===>打开页面方式 new新页面 old原页面
  let openAction = props.openAction
  let diaSize = props.pageList.openAction
  let customSize = props.pageList.customSize
  if (openInfo) {
    openAction = openInfo.openAction
    dialogSize.value = openInfo.diaSize
    customSize = openInfo.customSize
  }
  if (openAction === 'old') {
    router.push({
      name: 'oaExamineAuditPage',
      params: {
        data: param
      }
    })
  } else if (openAction === 'new') {
    let routeUrl = router.resolve({
      name: 'oaExamineAuditPage',
      query: {
        data: JSON.stringify(param)
      }
    });
    window.open(routeUrl.href, "_blank");
  } else {
    componentType.value = openAction
    if (diaSize === 'custom') {
      diaSize = customSize + '%'
    }
    dialogSize.value = diaSize
    param.delete = props.jurisdiction.delete
    param.myoplog = props.jurisdiction.myoplog

    AuditOpenChild.value.AuditOpenList(param)
  }
}


const tableDetail = async (row, isTodo = false, dataInfo, type = 'app-detail') => {
  if (row.row) {
    row = row.row
  }
  emit('click-row', row)
  detailOpenType.value = type
  if (isTodo === true) {
    const openType = {
      2: 'dialog',
      3: 'new',
      4: 'old',
      5: 'rightdia'
    }
    let open = 2
    let customSize = ''
    let diaSize = '80%'
    if (dataInfo.insideInfo) {
      const { popUps } = dataInfo.insideInfo
      open = dataInfo.insideInfo.open
      customSize = popUps.customSize
      diaSize = popUps.diaSize
    }
    const openInfo = {
      openAction: openType[open],
      customSize,
      diaSize
    }
    openDetail(row, openInfo)
    return
  }
  const clickEffect = props.dataInfo.clickEffect.effect
  if (clickEffect === 'notodo') {
    // TODO
  } else if (clickEffect === 'inside') {
    emit('click-table', row)
  } else {
    if (row && row.linkconfig && row.linkconfig.open && row.linkconfig.field && row.linktype && row.linktype === '1') {
      const v = row.linkconfig.field.split('_')[0]
      linkconfig.value = cloneDeep(row.linkConfig)
      await nextTick()
      widgetLinkOpenRef.value.open(row[v])
      return
    }
    openDetail(row)
  }
}

const tableUpdate = (data) => {
  //更新父级。因为是弹窗所以放到父组件上
  const param = {
    key: 2,
    data: data,
  };
  detailOpenType.value = 'detail'
  emit("sourceAudit", param);
}

const sourceAudit = () => {
  //来源oaExamineAudit.vue的方法
  emit("resetRefresh");
}

const archiveFun = async (item) => {
  const res = await archivedata({
    approvalId: route.query.approvalId || props.approvalId,
    approvingId: item.approvingId,
    isarchive: item.archive ? 0 : 1,
  });
  if (res.code === 0) {
    ElMessage.success(item.archive ? "解除归档成功！" : "归档成功！");
    item.archive = !item.archive;
  }
}

const getRowStyle = ({ row }) => {
  let color = ''
  if (props.dataInfo.listStyleConfig.valueConfig && props.dataInfo.listStyleConfig.valueConfig.color) color = props.dataInfo.listStyleConfig.valueConfig.color
  const scope = { row }
  for (const ele of tableKey.value) {
    const val = getValue(scope, ele)
    if (!ele.filedInfo) continue
    if (!ele.filedInfo.isColor) continue
    const colorType = ele.filedInfo.colorType
    const list = ele.filedInfo.list
    const styleInfo = getLabelColor({ options: list }, val, undefined, colorType)
    if (colorType === '3') {
      color = styleInfo.color
    }
  }
  return { height: '22px', cursor: props.dataInfo.clickEffect.effect === 'notodo' ? 'default' : 'pointer', '--color-row': color }
}

const getValue = (scope, val) => {
  return val.type === 'radio' && val.sels ? getRadioLabel(strData(scope.row[val.title], val.encrypt), val.sels) : strData(scope.row[val.title], val.encrypt)
}

const getRadioLabel = (val, item) => {
  if (!item || item.length === 0) return val
  for (const i of item) {
    if (i.value === val) return i.label
  }
  return val
}

const strData = (e, n) => {
  if (e instanceof Array) {
    //如果为数组
    if (e[0] && e[0].userId) {
      //如果有userId说明是联系人控件
      let ej = [];
      e.forEach((i) => {
        ej.push(i.realname);
      });
      return ej.join(",");
    } else if (e[0] && (e[0].organizationId || e[0].roleId)) {
      //如果有organizationId或roleId说明是组织控件或角色控件
      let ej = [];
      e.forEach((i) => {
        let name = i.name
        if (i.organizationId) {
          name = getOrgShowName(i)
        }
        ej.push(name);
      });
      return ej.join(",");
    } else {
      return e.join(",");
    }
  } else {
    return sliceEncrypt(e, n);
  }
}

const selectableFun = (row) => {
  //- cochain   上链0:无操作，1是上链中，2上链成功，3上链失败
  let whether = true;
  if (blockchainChange.value === true) {
    //- 区块链模式下
    //- 上链失败，无操作不能选中
    if (row["状态"] !== "已通过") {
      whether = false;
    } else {
      // if (row.cochain === 1 || row.cochain === 2) {
      //   whether = false;
      // }
    }
  } else {
    //- 正常模式下
    // if (row.cochain === 1 || row.cochain === 2) {
    //   whether = false;
    // }
  }
  //- return 值true是可以，false是不行
  return whether;
}

const indexMethods = (idx) => {
  const { currentPage, tablePageSize } = listData.value
  return tablePageSize * (currentPage - 1) + (idx + 1)
}

const showFiledName = (filed) => {
  let name = ''
  if (filed.filedInfo && filed.filedInfo.name) {
    name = filed.filedInfo.name
    const res = dealText({
      text: name,
      commonData: store.state.userData,
      customData: store.state.doorCustomData,
      functionParms: filed.filedInfo.functionParms || []
    })
    if (res) name = res
  } else {
    name = filed.name
  }
  return name
}

const goOpenOver = () => {

}

const openDetailInfo = (arge = [], row) => {
  const [type, dataInfo] = arge
  tableDetail(row, true, dataInfo, type)
}



// computed
const isNumFixed = computed(() => {
  if (Array.isArray(tableKey.value)) {
    const flag = tableKey.value.some(item => item.fixed)
    return flag
  } else {
    return false
  }
})

const delValueColor = computed(() => {
  const config = cloneDeep(props.dataInfo.listStyleConfig.valueConfig)
  delete config.color
  return config
})


const getCellHeight = computed(() => {
  if (props.dataInfo.tableStyleField.pageNum === 'textAdaption') {
    return ''
  } else if (props.dataInfo.tableStyleField.pageNum === 'lineAdaption') {
    let height = tableBodyHeight.value
    if (!height) {
      height = getBodyHeight()
    }
    return (height / props.dataInfo.tableStyleField.customPageNum) + 'px'
  } else {
    return props.dataInfo.tableStyleField.listLineHeight
  }
})

const isFixed = computed(() => {
  return props.dataInfo.tableStyleField.tableWidth === 'fixed'
})

const getMinWidth = computed(() => {
  let w = props.dataInfo.tableStyleField.tableWidth === 'fixed' ? '14' : 170
  return w
})

const tableLine = computed(() => {
  const { textLine, customLine } = props.dataInfo.tableStyleField
  const line = {
    '--line-': 1
  }
  if (textLine && textLine === 'custom') {
    line['--line-'] = customLine
  } else if (textLine) {
    line['--line-'] = textLine
  }
  return line
})

watch(() => props.listInfo.tableData, (newVal) => {
  if (!newVal) return
  const listInfo = props.listInfo
  listData.value = {
    currentPage: listInfo.currentPage,
    total: listInfo.tableTotal,
    pagesize: listInfo.tablePageSize,
    data: getResData(listInfo.tableData)
  }
  const oneData = listData.value.data[0]
  if (oneData && oneData.content && oneData.content.length > 0) {
    const obj = {}
    for (const i of listData.value.data[0].content) {
      if (i && i.type === 'text' && i.isLink && i.isLink === 'true') {
        obj[i.title] = true
      }
    }
    isLinkObj.value = obj
  } else {
    isLinkObj.value = {}
  }
}, { immediate: true })

watch(() => props.checkSyllable, (newVal) => {
  console.log(newVal,'newValnewValnewVal')
  tableKey.value = cloneDeep(newVal)
}, { immediate: true, deep: true })

watch(() => multipleSelection.value, (newVal) => {
  emit('update:multipleParentSelection', cloneDeep(newVal))
}, { immediate: true, deep: true })

defineExpose({
  clearCheckboxRow,
  updateElTable
})

</script>

<template>
  <div class="vxe-table-box" ref="vxeTableBox" v-if="Object.keys(dataInfo).length !== 0">
    <div class="vxe-table-box-body">
        <el-table
          :data="listData.data"
          height="100%"
          table-layout="auto"
          border
          :stripe="true"
          :header-cell-style="{
            background: '#f8f9fb',
            color: '#333',
            fontWeight: 'normal',
          }"
          :cell-style="{
            height: getCellHeight || '32px',
            lineHeight: getCellHeight|| '32px',
          }"
          ref="tableRef"
          :row-style="getRowStyle"
          @row-click="tableDetail"
          @cell-dblclick="(row, column, cell) => goTodoEdit({ row }, column, cell)"
          @selection-change="handleSelectionChange"
          @row-contextmenu="rowContextmenu"
          @vue:mounted="getBodyHeight"
          :header-row-class-name="hideSecondLevelHeader"
          :header-cell-class-name="'header_style'"
          :row-class-name="upClass"
          :key="uploadKey"
          >
          <template v-slot:empty>
            <template v-if="(dataInfo.tableStyleField.isInitTable === false) && !isGetListData">
              <initPage :config="dataInfo.initConfig" />
            </template>
            <template v-else>
              暂无数据
            </template>
          </template>
          <el-table-column
            type="selection"
            :selectable="selectableFun"
            class="selection-box"
            :index="9999"
            width="40"
          ></el-table-column>
          <el-table-column
            type="index"
            :width="getWidth('','num')"
            :min-width="getMinWidth"
            :index="indexMethods"
            :fixed="isNumFixed"
            v-if="dataInfo.tableStyleField.isSerialNumber"
          >
            <template v-slot:header>
              <div class="ellipsis" :style="[dataInfo.listStyleConfig.titleConfig]" style="text-align: left"> 序号 </div>
            </template>
            <template v-slot="scope">
              <div class="cell-item">
                <div style="width: 100%;" :style="[dataInfo.listStyleConfig.valueConfig]"> {{ scope.$index + 1 }} </div>
              </div>
            </template>
          </el-table-column>
          <template v-for="(val, valIdx) in tableKey" :key="val.title">
            <tableDetailCol
              :prop="val.title"
              :listTodoField="dataInfo.listTodoField"
              :activeCol="activeCol"
              :approvalId="approvalId"
              v-if="(val.isAppenFeild === undefined || val.isAppenFeild) && !val.isHide"
              :index="valIdx"
              :key="val.title"
              :label="val.type"
              :fixed="val.fixed"
              :column="val"
              :tableDetailData="dataInfo.listStyleConfig"
              :min-width="isFixed ? getWidth(val) : getMinWidth"
              :width="isFixed ? '' : getWidth(val)"
              :tableStyleField="dataInfo.tableStyleField"
              @handleEdit="handleDetailCol"
              @clearActiveCol="clearActiveCol"
            >
              <template v-slot:header>
                <div class="ellipsis door-header" :style="dataInfo.listStyleConfig.titleConfig" :title="val.name">
                  {{ showFiledName(val) }}
                  <OrderAndScreen @goSearch="$emit('goSearch', val, $event)" :info="val" />
                  <i class="iconfont icon-you" :class="val.isOpen ? 'trans' : ''" v-if="val.isViewOpen" @click="goOpenOver(val)"></i>
                </div>
              </template>
              <template v-slot="scope">
                <div :style="scope.row.renderMap[val.title].parentStyle" class="table-cell-div" :class="showTodoList[val.title] && showTodoList[val.title].info.moveAppen ? 'todo-btn-show' : ''">
                  <template v-if="val.type === 'image'">
                    <div class="list-app-img" :style="scope.row.renderMap[val.title].style" style="display: flex;">
                      <div @click.stop class="list-app-img-item" :key="imgIndex"
                        v-for="(img, imgIndex) in scope.row.renderMap[val.title].display" style="width: initial;">
                        <el-image style="width: initial;height: 100%;" preview-teleported :src="img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()" :preview-src-list="[img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()]"  fit="cover" />
                      </div>
                    </div>
                  </template>
                  <template v-else-if="val.type === 'file'">
                    <div class="img-file">
                      <div v-for="(item2, idx2) in scope.row.renderMap[val.title].display" :key="idx2" class="img-file-style"
                        style="width: 100%;">
                        <i class="iconfont icon-wenjianfujian"></i>
                        <span @click.stop="goPreview(item2, false)" :style="{ fontSize: props.dataInfo.listStyleConfig.valueConfig.fontSize }" type="primary" style="width: fit-content;"
                          class="img-file-content">
                          {{ item2.display }}
                        </span>
                        <span @click.stop="goPreview(item2, true)" class="img-file-icon">
                          <i class="iconfont icon-xiazai2x"></i>
                        </span>
                        <span v-if="val.isFileEdit" @click.stop="goPreview(item2, false, true)" class="img-file-icon">
                          <i class="iconfont icon-bianji1"></i>
                        </span>
                        <el-link v-if="getFileFormat(item2.response)" type="primary" style="margin-left: 5px;"
                          @click.stop="playFun(item2)">
                          <i class="iconfont icon-bofang"></i>
                        </el-link>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="val.type === 'relation-check'">
                    <tableRead v-if="getRelCheck(scope.row[val.title])"
                      :config="{ list: getRelCheck(scope.row[val.title]).top, title: scope.$index }"
                      :formdata="getRelCheck(scope.row[val.title])" />
                    <template v-else>{{ strData(scope.row[val.title], val.encrypt) }}</template>
                  </template>
                  <template v-else-if="val.type === 'query'">
                    <template v-if="scope.row[val.title] === ''">
                      <div class="btn-query" @click.stop="queryData(scope.row, val)">
                        <i class="iconfont icon-sousuo" />
                        点击查询
                      </div>
                    </template>
                    <template v-else>
                      <template v-if="typeof scope.row[val.title] == 'object'">
                        <p v-for="(item, index) in scope.row[val.title]" :key="index">{{ index + 1 }}.{{ item }}</p>
                      </template>
                      <span v-else>{{ scope.row[val.title] }}</span>
                    </template>
                  </template>
                  <template v-else-if="val.type === 'location'">
                    {{ getLocationVal(scope.row[val.title]) }}
                  </template>
                  <template v-else-if="val.title === '状态'">
                    <div :class="scope.row.renderMap[val.title].statusClass"
                      :style="[delValueColor, scope.row.renderMap[val.title].style]" class="status-class door-ellipsis">{{
                        scope.row[val.title] }}</div>
                  </template>
                  <template v-else-if="val.title === '归档状态'">
                    <div :style="[scope.row.renderMap[val.title].style]" class="status-class door-ellipsis">
                      {{ scope.row.renderMap[val.title].display }}
                    </div>
                  </template>
                  <template v-else-if="val.type === 'relation-user'">
                    <template v-if="Array.isArray(scope.row[val.title])">
                      <div :style="scope.row.renderMap[val.title].style" style="display: flex;align-items: center;">
                        <template v-for="(item, userIdx) in scope.row[val.title]" :key="item.userId" >
                          <div style="width: fit-content;white-space: nowrap;" class="relation-user-content" v-if="val.isMoreInfo">
                            <relationUserInfo :info="item" :moreInfo="val.moreInfoArr"
                              :checkedInfo="showTodoList[val.title] && showTodoList[val.title].checkKey"
                              :isNewInfo="item.isNewData" iconColor='#4E86FF' />
                          </div>
                          <template v-else>{{ item.realname }}{{ userIdx === scope.row[val.title].length - 1 ? '' : ',' }}</template>
                        </template>
                      </div>
                    </template>
                  </template> 
                  <template v-else-if="['details', 'richTextWid'].includes(val.type)">
                    <div class="rich-text">
                      <div class="rich-text-style"
                        :style="[dataInfo.listStyleConfig.valueConfig, { justifyContent: getConfigCenter(dataInfo.listStyleConfig.valueConfig.textAlign) }]"
                        @click.stop="openRichAndDetails(scope, val)">
                        <i class="iconfont icon-shujuchaxun"></i>
                        <span class="text">{{ dataInfo.tableStyleField.isTodoList && showTodoList[val.title] &&
                          showTodoList[val.title].info ? scope.row.renderMap[val.title].placeholder || '请点击查看' : '请点击查看' }}</span>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="val.type === 'radio' && dataInfo.tableStyleField.isTodoList && showTodoList[val.title] && (showTodoList[val.title].types === 4 || showTodoList[val.title].types === 6)">
                    <template v-if="showTodoList[val.title].types === 4">
                      <div class="radio-switch" @click.stop :style="scope.row.renderMap[val.title].style">
                        <template
                          v-if="showTodoList[val.title].switchStyle && showTodoList[val.title].switchStyle === 3">
                          <div
                            :class="['radio-checkbox', scope.row[val.title] === getSwitchColor({ ele: showTodoList[val.title], type: 'active', isGet: true }) ? 'radio-checkbox-active' : '']"
                            @click="upCheckbox({ val: scope.row[val.title] === getSwitchColor({ ele: showTodoList[val.title], type: 'active', isGet: true }) ? getSwitchColor({ ele: showTodoList[val.title], type: 'inactive', isGet: true }) : getSwitchColor({ ele: showTodoList[val.title], type: 'active', isGet: true }), item: showTodoList[val.title], row: scope.row, title: val.title })">
                              <el-icon>
                                <Check />
                              </el-icon>
                          </div>
                        </template>
                        <el-switch v-else
                          :active-value="getSwitchColor({ ele: showTodoList[val.title], type: 'active', isGet: true })"
                          :inactive-value="getSwitchColor({ ele: showTodoList[val.title], type: 'inactive', isGet: true })"
                          :active-color="getSwitchColor({ ele: showTodoList[val.title], type: 'active' })"
                          :inactive-color="getSwitchColor({ ele: showTodoList[val.title], type: 'inactive' })"
                          :inactive-text="showTodoList[val.title].switchStyle === 1 ? '' : getSwitchColor({ ele: showTodoList[val.title], type: 'inactive', isGet: true })"
                          :active-text="showTodoList[val.title].switchStyle === 1 ? '' : getSwitchColor({ ele: showTodoList[val.title], type: 'active', isGet: true })"
                          :model-value="getResValue(strData(scope.row[val.title], val.encrypt), val)"
                          style="width: initial;height: initial;"
                          @change="changeSwitchValue({ val: $event, item: showTodoList[val.title], row: scope.row })" />
                      </div>
                    </template>
                    <template v-else-if="showTodoList[val.title].types === 6">
                      <radioXing :sels="val.sels" :value="scope.row[val.title]"
                        :edit="!!(dataInfo.tableStyleField.isTodoList && showTodoList[val.title])"
                        @upXing="changeRadioValue({ val: $event, item: showTodoList[val.title], row: scope.row })" />
                    </template>
                  </template>
                  <template v-else-if="val.type === 'checkbox'">
                    <div :style="[scope.row.renderMap[val.title].style, labelColor(check, val)]" class="table-content door-ellipsis" v-for="(check, checkIdx) in scope.row.renderMap[val.title].display" :key="checkIdx">
                      {{ check }}
                    </div>
                  </template>
                  <template v-else>
                    <div :style="scope.row.renderMap[val.title].style" class="table-content door-ellipsis">
                      {{ showTodoList[val.title] ? ((scope.row.renderMap[val.title].display + '') || scope.row.renderMap[val.title].placeholder) : scope.row.renderMap[val.title].display }}
                    </div>
                  </template>
                  <buttonStyle
                    class="list-todo-btn"
                    v-if="dataInfo.tableStyleField.isTodoList && showTodoList[val.title] && showTodoList[val.title].info.interactive === 'buttonClick' && showTodoList[val.title].types !== 4 && !(['details', 'richTextWid'].includes(val.type))" 
                    :info="{ info:showTodoList[val.title].info }"
                    @click.stop="goTodoEdit(scope, { property:val.title, label: val.type }, undefined, $event)" />
                </div>
              </template>
            </tableDetailCol> 
          </template>
          <el-table-column
            width="auto"
            align="center"
            fixed="right"
            v-if="(dataInfo.clickEffect.todoNav === 'open' || dataInfo.clickEffect === undefined)"
          >
            <template v-slot:header>
              <div class="ellipsis" :style="[dataInfo.listStyleConfig.titleConfig, { textAlign: 'center' }]"> 操作
              </div>
            </template>
            <template v-slot="scope">
              <div class="table-todo">
                <simpleButton v-for="comp in scope.row.todoList" size="16px"
                  :isTable="true" :btnHeight="`${parseInt(dataInfo.tableStyleField.listLineHeight || '32px') - 2}px`"
                  :info="{ info: comp }" :key="comp.id" :class="{
                    'dataArchiving': scope.row.archive && comp.id === 6
                  }" class="table-todo-item" @btnClick="tableTodoClick($event, scope)" @openTips="openBtnTips">
                </simpleButton>
                <div class="table-todo-img-tip table-todo-item" v-if="scope.row.hasOwnProperty('transfile')">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.transfile ? '解析成功' : '解析失败'"
                    placement="bottom"
                  >
                    <img
                      @click.stop
                      style="display:block;width:18px;height:17px;margin-left:5px;"
                      :src="'https://bigdata.topeti.com/PCRepository/mainPlatform/analysis-' + (scope.row.transfile ? 'success.svg' : 'fail.svg')"
                    />
                  </el-tooltip>  
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      <div class="reload" v-if="dataInfo.tableStyleField.isOpenReload !== false" @click="emit('resetRefresh')" title="刷新数据">
        <i class="WSiconfont WSicon-zhongzhiicon"></i>
      </div>
    </div>
    <el-pagination class="vxe-table-box-foot" small background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-size="listData.pagesize" :page-sizes="pageSizes"
      :current-page="listData.currentPage ? listData.currentPage : 1" layout="total, sizes, prev, pager, next, jumper"
      :total="listData.total" />
    <widgetLinkOpen ref="widgetLinkOpenRef" :linkConfig="linkconfig" diaSize="80%" />
    <oaExamineAudit ref="AuditOpenChild" :openType="componentType" :diaSize="dialogSize" :viewDetailFun="detailOpenType"
      :tableStyleField="dataInfo.tableStyleField" v-on:sourceAudit="sourceAudit" @edit-btn="tableUpdate"
      @dataArchiving-btn="archiveFun" @del-btn="(approvingId) => { deleteRow(3, approvingId) }"></oaExamineAudit>
    <swipeIndex ref="swipeIndexRef" @swipeRet="swipeRet" />
    <log v-model:isLogView="isViewLog" :approvalId="approvalId" :approvingId="logApprovingId" />
    <batchDialog v-model:visible="batch.visible" @close="closeBatchDialog" :date="batch" :approvalId="approvalId" @batch="batchRet" />
    <!-- 打印预览 -->
    <!-- <print-box ref="printBox" :key=" 'print' + printBoxKey"
      v-model:isView="printBoxShow"
      v-model:isOpen="printBoxOpen"
      :title="printTitle" 
      :formdata="printFormdata"
      :detailConfig="printBoxConfig"
      :deptGroup="deptGroup"
      @close="printBoxKey++">
    </print-box> -->
    <oaAddExamineInput v-model:isViews="addDataShow" :applyInfo="approvalInfo" :coverVal="coverVal" :isAllAdd="isAllAdd" @updateTable="emit('updateTable')" />
    <annotationTips ref="tipsRef" />
    <TodoEdit ref="todoEdit" :height="dataInfo.tableStyleField.listLineHeight" :appendToBody="!!dataInfo.tableStyleField.isTodoDiagle" @change="todoChange" :approvalId="approvalId" @close="closeTodoEdit" />
    <context-menu v-if="showMenu" :menu-items="tempBtnMenu" :position="menuPosition" @close="menuClose"  @item-click="handleMenuClick" />
    <detailReadonly ref="detailReadonlyRef" @confirm="todoChange" />
    <allmultiple-choice ref="allMultipleChoiceRef" v-on:fromMultipleChoice="orgChoiceMethod" v-show="isAllMultipleChoice" :isSpace="isSpace"></allmultiple-choice>
    <richTextEdit :richTitle="tempRichAndDetailsName" :isReadonly="isRichTextReadonly" :width="`${approvalInfo.pdwidth || 60}%`" :isAppendRightTools="false" @submit="richTextEditCallBack" ref="richTextEditRef" />
  </div>
</template>

<style scoped lang='scss'>
.vxe-table-box {
  height: 100%;
  display: flex;
  flex-direction: column;

  &-body {
    flex: 1;
    overflow: hidden;
  }

  &-foot {
    height: 40px;
    display: flex;
    justify-content: flex-end;
  }
}

.radio-checkbox {
  width: 14px !important;
  height: 14px;
  position: relative;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
  display: inline-block;

  i {
    display: none;
  }
}

.radio-checkbox-active {
  background-color: #4e86ff;
  border-color: #4e86ff;

  i {
    display: block;
    font-size: 14px;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.text-link {
  text-decoration: underline;
  color: #4e86ff;
  cursor: pointer;
}

.relation-user-content {
  display: inline-block;
  margin-right: 2px;
}

.rich-text {
  .rich-text-todo {
    .text {
      color: rgb(192, 196, 204) !important;
    }
  }

  .rich-text-style {
    color: #4e86ff;
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;

    .text {
      margin-left: 5px;
      color: #4e86ff;
    }

    .icon-shujuchaxun {
      color: #4e86ff;
      font-size: 14px;
    }
  }
}

.flex-w-h-full {
  display: flex;
  width: 100%;
  height: 100%;
}

.status-class {
  display: flex;
  width: 100%;
  height: 100%;
  margin: 0 !important;
}

.cell-item {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.input-color {
  color: #999999 !important;
}

.todo-btn-show {
  .list-todo-btn {
    display: none;
  }

  &:hover {
    .list-todo-btn {
      display: block;
    }
  }
}

.list-todo-btn {
  width: fit-content !important;
}



.reload {
  position: absolute;
  bottom: 20PX;
  right: 20px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  background: #FFFFFF;
  box-shadow: -1px 3px 12px 1px rgba(15, 5, 10, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;

  .WSicon-zhongzhiicon {
    font-size: 20px;
  }
}

::v-deep .radio-switch {
  display: flex;
  align-items: center;
  .el-switch__label {
    white-space: nowrap;
  }
}


::v-deep .stat-block {
  line-height: 23px;
  height: auto;
}

.door-header {
  position: relative;
  
  .icon-you {
    font-size: 12px;
    color: #E1E1E1;
    transform: scale(.7);
    cursor: pointer;
    display: inline-block;
    transition: .3s;
    position: absolute;
    right: 0;
  }

  ::v-deep .order-and-screen {
    opacity: 0;
  }

  ::v-deep &:hover {
    .order-and-screen {
      opacity: 1;
    }
  }

  .trans {
    transform: rotate(180deg) scale(.7);
  }
}

.list-app-img {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  &-item {
    display: flex;
    align-items: center;
    margin-left: 5px;
    width: 28px;
    height: 28px;
    position: relative;
    overflow: hidden;
    .img-mask {
      transition: .3s;
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.48);
      left: 0;
      top: 0;
      transform: translateX(-100%);
      .el-icon-delete {
        font-size: 12px;
        cursor: pointer;
        color: #fff;
      }
    }
    &:hover {
      .img-mask {
        transform: translateX(0);
      }
    }
  }
  .todo-img {
    position: relative;
    overflow: hidden;
  }
  .todo-upload {
    width: 28px;
    height: 28px;
    border: solid 1px #DCDFE6;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

.img-file {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;

  .todo-upload {
    width: 28px;
    height: 28px;
    border: solid 1px #DCDFE6;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: auto;
  }

  .icon-wenjianfujian {
    color: #999999;
    font-size: 14px;
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    height: 26px;
  }

  &-style {
    margin-left: 20px;
    display: flex;
    align-items: center;
    overflow: hidden;

    .el-icon-delete {
      color: #e47470;
      cursor: pointer;
    }

    .img-file-content {
      cursor: pointer;
      padding-right: 5px;
      color: #4e86ff;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;

      // flex: 1;
      &:hover {
        text-decoration: underline;
      }
    }

    .img-file-icon {
      cursor: pointer;

      .icon-xiazai2x {
        font-size: 14px;
        color: #4e86ff;
      }
    }
  }
}

::v-deep .cell .el-button--small {
  padding-top: 0;
  padding-bottom: 0;
}

.list-search {
  display: inline-block;

  ::v-deep .el-input__inner {
    border-right: none;
    border-radius: 4px 0 0 4px;
  }

  ::v-deep .el-button {
    border-radius: 0 2px 2px 0;
    margin-left: -4px;
  }
}

.tmTibs .el-tabs__nav {
  margin-left: 30px;
  padding: 10px 0;
}

.tmTibs .el-tabs__nav .el-tabs__item {
  font-size: 16px !important;
}

::v-deep .el-table {
  .el-table__body {
    .el-table__row {
      .el-table__cell {
        padding: 0 !important;
      }
    }
    .el-table__body-header {
      .row-header-style {
        .el-table__cell {
          padding: 0 !important;
        }
      }
    }
  }
}

.row_style {
  color: #000;
  cursor: pointer;
}

::v-deep .row_style {
  height: 36px;
}
</style>
<style lang="scss" scoped>
::v-deep .el-table__fixed-body-wrapper {
  top: 37px !important;
}

::v-deep .dataArchiving {
  .icon-guidang {
    color: #9013FE !important;
  }
}

::v-deep .batch {
  margin-left: 20px;
  display: inline-block;

  .title {
    margin: 0 4px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #333333;
    font-size: 14px;
  }

  .el-icon-arrow-down {
    font-size: 10px;
  }
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #965500;
  background: rgba(255, 253, 246, 1);
}

.button-list:hover .button-list-text {
  color: #965500;
}

.button-list {
  display: inline-block;
  margin-left: 25px;
  font-size: 16px;
}

.door-ellipsis {
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--line-);
  overflow: hidden;
}

.nowrap {
  white-space: nowrap;
}

.button-list-text {
  font-size: 14px;
  vertical-align: text-top;
}

.cor-400 {
  color: #ffb400;
}

.menuList {
  background: #f4f4f9;
  height: 100%;
  position: relative;
  z-index: 99;
}

.menuList>p {
  position: absolute;
  background: #fff;
  width: 26px;
  height: 26px;
  right: -13px;
  border-radius: 50%;
  border: 1px solid #ddd;
  top: 46%;
  cursor: pointer;
  z-index: 5;
  text-align: center;
  line-height: 26px;
}

.menuList>p i {
  color: #4e86ff;
  font-size: 14px;
}

.menuList ul {
  padding-top: 18px;
  overflow: hidden;
}

.todo-icon-color {
  color: #999 !important;

  &:hover {
    color: #4e86ff !important;
  }
}

.todo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.icon-guidang {
  &:hover {
    color: #4e86ff;
    ;
  }
}

.menuList ul li {
  margin-right: 10px;
  display: block;
  padding: 10px 0 10px 42px;
  cursor: pointer;
  color: #333;
}

.menuList ul li.active {
  background: #d2d2e1;
  color: #000;
}

.menuList ul li:hover {
  background: #e0e0eb;
}

.content {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0px;
  overflow: auto;
  left: 225px;
}

.demo-form-inline {
  float: left;
}

.page {
  position: absolute;
  bottom: -45px;
  padding: 6px 2% 6px 0;
  right: 0;
  width: 80%;
  // max-width: calc(100% - 350px);
  text-align: right;
  background: #fff;
  z-index: 5;
}

.el-icon--right {
  padding: 0 10px;
}

.nopadding {
  padding: 0;
}


::v-deep .table-todo {
  width: 100%;
  height: 100%;
  min-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;

  &-item {
    margin-right: 8px;
    width: initial !important;

    .btn-popover {
      max-height: 26px !important;
      height: initial !important;

      .container-btn-pop {
        .buttonStyle {
          height: 26px !important;
        }
      }
    }
  }
}

.el-button+.el-button {
  margin-left: 0;
}


.dialog-body {
  padding: 16px;
}

.dialog-body .el-checkbox {
  padding-bottom: 12px;
}

.dialog-foot {
  padding: 10px 16px;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;

  &-btn {
    flex: 1;
    text-align: right;
  }
}

.searchRow {
  height: 40px;
  overflow: hidden;
}

.searchList {
  height: 40px;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.searchMore {
  text-align: center;
  font-size: 20px;
  color: #4e86ff;
}

.searchMore i {
  cursor: pointer;
}

::v-deep .el-button {
  font-weight: 400;
}

.nav-top {
  padding-top: 5px;
  position: relative;

  .nav-top-filter {
    padding-left: 30px;
    color: #333333;

    &:hover {
      color: #4e86ff;
    }
  }
}

.nav-top .top-set {
  text-align: right;
}

.nav-top .top-set i {
  color: #999999;
}

.pos-list-mom-y {
  min-height: 65px;
  width: 100%;
}

.pos-list-mom {
  min-height: 38px;
  position: absolute;
  left: 7px;
  padding-left: 10px;
  z-index: 999;
  width: calc(100% - 20px);
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 235, 235, 1);
  box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.16);
  padding-bottom: 15px;
}

.icon-bottom:after,
.icon-bottom-yes {
  content: ">>";
}

.icon-bottom {
  display: inline-block;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg) scale(1, 1.9);
  letter-spacing: -3px;
  font-size: 12px;
  color: #999999;
  position: relative;
  top: -3px;
}

.icon-bottom-yes {
  letter-spacing: -3px;
  font-size: 14px;
  color: #965500;
  display: block;
  -webkit-transform: rotate(-90deg) scale(1, 1.9);
  -moz-transform: rotate(-90deg) scale(1, 1.9);
  -ms-transform: rotate(-90deg) scale(1, 1.9);
  -o-transform: rotate(-90deg) scale(1, 1.9);
  transform: rotate(-90deg) scale(1, 1.9);
}

.mom-text-yes {
  display: inline-block;
  position: absolute;
  bottom: -35px;
  left: 50%;
  transform: translateX(-50%);
  width: 65px;
  height: 55px;
  padding-top: 10px;
  background: rgba(255, 246, 217, 1);
  border: 2px solid rgba(216, 166, 0, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 50%;
  text-align: center;
  color: #965500;
  font-size: 14px;
}

::v-deep .hidden-header {
  display: none;
}


.mom-text-yes-title {
  padding-top: 8px;
  display: block;
}

.mom-text {
  width: 180px;
  color: #999999;
  font-size: 14px;
  padding-top: 11px;
  position: relative;
  left: 50%;
  margin-left: -90px;
  transform: translateX(-50%);
  display: inline-block;
}

.parting {
  width: 1px;
  height: 13px;
  background: #e5e5e5;
  display: inline-block;
  vertical-align: sub;
}

.goInfo {
  border: 1px solid #b66200;
  background: #fffcea;
  font-size: 14px;
  color: #b66200;
}

.text-remark {
  position: absolute;
  top: 0;
  left: 0;
  background: #312d28;
  color: #ffffff;
  font-size: 14px;
  padding: 10px;
}

.tranHeight {
  padding-bottom: 20px;
  /*padding-top: 10px;*/
}

.el-button--primary.is-plain {
  background: none;
  border: none;
  color: black;
}

.blockchain {
  display: inline-block;

  .change {
    cursor: pointer;

    i {
      color: #4e86ff;
      font-size: 110%;
    }
  }
}

.btn-query {
  color: #4E86FF;
  cursor: pointer;
}

.query-list {
  height: 100px;

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}

.table-cell-div {
  display: flex;
  align-items: center;
  height: 100%;
  div {
    width: 100%;
  }
}

.img-file {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  height: 100%;
  .todo-upload {
    width: 28px;
    height: 28px;
    border: solid 1px #DCDFE6;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: auto;
  }
  .icon-wenjianfujian {
    color: #999999;
    font-size: 14px;
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    height: 26px;
  }
  &-style {
    margin-left: 20px;
    display: flex;
    align-items: center;
    overflow: hidden;
    .el-icon-delete {
      color: #e47470;
      cursor: pointer;
    }
    .img-file-content {
      cursor: pointer;
      padding-right: 5px;
      color: #4e86ff;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      // flex: 1;
      &:hover {
        text-decoration: underline;
      }
    }
    .img-file-icon {
      margin-right: 4px;
      cursor: pointer;
      .icon-xiazai2x, .icon-bianji1 {
        font-size: 14px;
        color: #4e86ff;
      }
    }
  }
}

/*状态显示效果*/
.processing {
  color: #4e86ff !important;
  background-color: transparent;
  border: none;
}

.passed {
  color: #19B359 !important;
  background-color: transparent;
  border: none;
}

.refuse {
  color: #D44C4C !important;
  background-color: transparent;
  border: none;
}

.cancel {
  background-color: transparent;
  border: none;
  color: #666666 !important;
}

::v-deep .el-table {
  .el-scrollbar {
    .el-scrollbar__wrap {
      overflow-x: initial !important;
    }
  }
}


</style>
